const state = () => ({
    combo: null,
    comboItems: [],
    comboItemProducts: [],
    comboItemProductOffers: [],
    comboItemGroupId: null
})

// getters
const getters = {
    getCombo: (state) => {
        return state.combo;
    },
    getComboItems: (state) => {
        return state.comboItems;
    },
    getComboItemProducts: (state) => {
        return state.comboItemProducts;
    },
    getComboItemProductOffers: (state) => {
        return state.comboItemProductOffers;
    },
    getComboItemGroupId: (state) => {
        return state.comboItemGroupId;
    },
}

// actions
const actions = {}

// mutations
const mutations = {
    setCombo: (state, value) => {
        state.combo = value;
    },

    setComboItems: (state, value) => {
        state.comboItems = value;
    },

    setComboItemProducts: (state, value) => {
        state.comboItemProducts = value;
    },

    setComboItemProductOffers: (state, value) => {
        state.comboItemProductOffers = value;
    },

    setComboItemGroupId: (state, value) => {
        state.comboItemGroupId = value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
